import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.sampleReceivedDetails || initialState;

export const selectOrderDetails = createSelector(
  [selectDomain],
  (state) => state.orderDetails
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectSampleDetails = createSelector(
  [selectDomain],
  (state) => state.sampleDetails
);
export const selectLoadingSampleDetails = createSelector(
  [selectDomain],
  (state) => state.loadingSampleDetails
);
